import { configureStore } from '@reduxjs/toolkit';
import authSlice from './User/auth-slice';
import appSlice from './app/app-slice';

const store = configureStore({
	reducer: { user: authSlice, app: appSlice }
});

export default store;
